import { Country, Language } from 'types/Api'

export const countryToLanguagesMap: Record<Country, (Language | 'nn')[]> = {
  dk: ['da', 'no', 'nn'],
  es: ['es'],
  fr: ['fr'],
  se: ['sv'],
  no: ['no', 'nn'],
}
